import { useMemo } from "react";
import { useWindowSize } from "usehooks-ts";
import { BREAKPOINT_MOBILE_PIXELS } from "../../data/constants";

export function useIsMobile(): boolean {
  const { width } = useWindowSize();
  const isMobile = useMemo(() => width <= BREAKPOINT_MOBILE_PIXELS, [width]);
  return isMobile;
}
